import { useState, useRef, useEffect } from "react";
import InactivityService from "../../utils/inactivity-service";

export type InactivityContextType = {
  isInactive: boolean;
};

export const useInactivity = () => {
  const inactivityRef = useRef<InactivityService | null>(null);

  const [isInactive, setIsInactive] = useState<boolean>(false);

  useEffect(() => {
    if (!inactivityRef.current) {
      inactivityRef.current = new InactivityService(setIsInactive);
      inactivityRef.current.start();
    }

    // cleanup on unmount or rerun so we don't have multiple listeners
    return () => {
      inactivityRef.current?.stop();
    };
  }, []);

  return isInactive;
};
